import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './containers/App';
import reportWebVitals from './reportWebVitals';
import axios from "axios";
import {API_URL} from "./utils/constants";
import {BrowserRouter} from "react-router-dom";
import Storage from "./utils/Storage";
import ScrollToTop from "./ScrollToTop";
import momentTimezone from 'moment-timezone';

axios.defaults.baseURL = API_URL
axios.defaults.headers.common.Authorization = `Bearer ${Storage.token}`
axios.defaults.headers.common.company_id = Storage.getData('company_id')
// ROAR-4801/ROAR-4844: mirrors the line above's race-avoidance (set before React mounts, so
// early requests don't fire without it) — GlobalCompanySelection's own effect re-sets this on
// mount too, but that's after the component tree renders. Decrypting here (unlike the raw
// pass-through above) can throw on a stale blob encrypted under a previous jwt.siemba — guarded
// so that doesn't block the whole app from mounting.
let selectedCompanyUuid = null
try {
    selectedCompanyUuid = JSON.parse(Storage.decryptStorageData('company_id'))?.uuid || null
} catch (e) {
    // fall through with no MSSP company selected yet — the user will reselect from the dropdown
}
axios.defaults.headers.common.selected_company_uuid = selectedCompanyUuid
axios.defaults.headers.common.timezone = momentTimezone?.tz?.guess()

const rootEl = document.getElementById('root');
const root = createRoot(rootEl);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ScrollToTop/>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
